<h2 mat-dialog-title>Настройка импорта файла</h2>
<form class="drop-padding" [formGroup]="form" (ngSubmit)="save()">
  <mat-form-field appearance="outline">
    <mat-label>Наименование</mat-label>
    <input matInput type="text" formControlName="description" />
  </mat-form-field>
  <mat-form-field appearance="outline">
    <mat-label>Производитель</mat-label>
    <input matInput type="text" formControlName="brand" />
  </mat-form-field>
  <mat-form-field appearance="outline">
    <mat-label>Артикул</mat-label>
    <input matInput type="text" formControlName="article" />
  </mat-form-field>
  <mat-form-field appearance="outline">
    <mat-label>Цена</mat-label>
    <input matInput type="text" formControlName="price" />
  </mat-form-field>
  <div mat-dialog-actions align="end">
    <button mat-button type="button" mat-dialog-close>Отмена</button
    ><button mat-flat-button type="submit" color="primary">Сохранить</button>
  </div>
</form>
